import styled from "styled-components";

export const MenuWrapper = styled.nav`
  position: relative;
  display: flex;
  margin: 20px 0;

  & > ul {
    position: relative;
    display: flex;
    padding: 0;
    margin: 0;
  }

  @media only screen and (max-width: 580px) {
    margin: 0;
    & > ul {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`

export const MenuItem = styled.li`
  position: relative;
  list-style: none;
  padding: 15px 30px;
  outline: 1px solid transparent;
  font-size: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #999999;
  transition: color 0.2s ease-out, border-bottom 0.2s ease-out, outline-color 0.2s ease-out;

  &:not(.active):hover,
  &:not(.active):focus {
    color: #ffffff;
    outline: 1px solid #ffffff;
    cursor: pointer;
  }

  &.active {
    color: #ffffff;
    cursor: pointer;

    & > span::after {
      width: 100%;
    }
  }

  & > span {
    position: relative;
    display: block;

    &::after {
      content: '';
      position: absolute;
      margin: 0 auto;
      height: 1px;
      width: 0;
      bottom: -8px;
      left: 0;
      right: 0;
      background-color: #ffffff;
      transition: width 0.2s ease-out;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 8px 12px;
    font-size: 14px;
  }

  @media only screen and (max-width: 580px) {
    padding: 3px 10px;
    width: 50%;
    box-sizing: border-box;
    text-align: center;
    justify-content: center;
  }

  @media only screen and (max-width: 450px) {
    padding: 3px 6px;
    letter-spacing: 0;

    &:not(.active):hover,
    &:not(.active):focus {
      outline: 1px solid transparent;
    }
  }
`

export const DropdownMenuItem = styled.li`
  position: relative;
  list-style: none;
  padding: 15px 30px;
  outline: 1px solid transparent;
  font-size: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #999999;
  transition: color 0.2s ease-out, outline-color 0.2s ease-out;
  cursor: pointer;

  &:hover,
  &:focus {
    color: #ffffff;
    outline: 1px solid #ffffff;
  }

  &:hover > ul,
  &:focus-within > ul {
    opacity: 1;
    visibility: visible;
    max-height: 50px;
    pointer-events: auto;
  }

  & > span {
    position: relative;
    display: block;
  }

  @media only screen and (max-width: 600px) {
    padding: 8px 12px;
    font-size: 14px;
  }

  @media only screen and (max-width: 580px) {
    padding: 3px 10px;
    width: 50%;
    box-sizing: border-box;
    text-align: center;
    justify-content: center;
  }

  @media only screen and (max-width: 450px) {
    padding: 3px 6px;
    letter-spacing: 0;

    &:hover,
    &:focus {
      outline: 1px solid transparent;
    }
  }
`

export const DropdownList = styled.ul<{ $open?: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #05080b;
  outline: 1px solid #ffffff;
  padding: 0;
  margin: 0;
  z-index: 100;
  opacity: ${({ $open }) => $open ? 1 : 0};
  visibility: ${({ $open }) => $open ? 'visible' : 'hidden'};
  max-height: ${({ $open }) => $open ? '50px' : '0'};
  overflow: hidden;
  transition: opacity 0.2s ease, visibility 0.2s, max-height 0.2s ease;
  pointer-events: ${({ $open }) => $open ? 'auto' : 'none'};
`

export const DropdownItem = styled.li`
  list-style: none;
  padding: 10px 20px;
  margin-bottom: 0;
  font-size: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #999999;
  white-space: nowrap;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: #ffffff;
    background: #131825;
    cursor: pointer;
  }

  @media only screen and (max-width: 600px) {
    font-size: 11px;
    padding: 6px 12px;
  }

  @media only screen and (max-width: 450px) {
    font-size: 11px;
    padding: 5px 6px;
  }
`
